import axios from 'axios';

const dismiss = async (id: string) => axios.delete(`/listing/duplicates/${id}`);

export default dismiss;
